/*** IMPORTS FROM imports-loader ***/
var createjs = window.createjs;

(function (lib, img, cjs, ss, an) {

var p; // shortcut to reference prototypes
lib.webFontTxtInst = {}; 
var loadedTypekitCount = 0;
var loadedGoogleCount = 0;
var gFontsUpdateCacheList = [];
var tFontsUpdateCacheList = [];
lib.ssMetadata = [
		{name:"maket_atlas_", frames: [[858,0,162,162],[522,0,170,170],[889,164,129,136],[0,176,129,136],[694,0,162,162],[350,0,170,170],[0,0,174,174],[717,164,170,151],[176,0,172,170],[131,226,129,136],[262,226,129,136],[393,226,129,136],[524,226,129,136],[176,172,539,52]]}
];



lib.updateListCache = function (cacheList) {		
	for(var i = 0; i < cacheList.length; i++) {		
		if(cacheList[i].cacheCanvas)		
			cacheList[i].updateCache();		
	}		
};		

lib.addElementsToCache = function (textInst, cacheList) {		
	var cur = textInst;		
	while(cur != null && cur != exportRoot) {		
		if(cacheList.indexOf(cur) != -1)		
			break;		
		cur = cur.parent;		
	}		
	if(cur != exportRoot) {		
		var cur2 = textInst;		
		var index = cacheList.indexOf(cur);		
		while(cur2 != null && cur2 != cur) {		
			cacheList.splice(index, 0, cur2);		
			cur2 = cur2.parent;		
			index++;		
		}		
	}		
	else {		
		cur = textInst;		
		while(cur != null && cur != exportRoot) {		
			cacheList.push(cur);		
			cur = cur.parent;		
		}		
	}		
};		

lib.gfontAvailable = function(family, totalGoogleCount) {		
	lib.properties.webfonts[family] = true;		
	var txtInst = lib.webFontTxtInst && lib.webFontTxtInst[family] || [];		
	for(var f = 0; f < txtInst.length; ++f)		
		lib.addElementsToCache(txtInst[f], gFontsUpdateCacheList);		

	loadedGoogleCount++;		
	if(loadedGoogleCount == totalGoogleCount) {		
		lib.updateListCache(gFontsUpdateCacheList);		
	}		
};		

lib.tfontAvailable = function(family, totalTypekitCount) {		
	lib.properties.webfonts[family] = true;		
	var txtInst = lib.webFontTxtInst && lib.webFontTxtInst[family] || [];		
	for(var f = 0; f < txtInst.length; ++f)		
		lib.addElementsToCache(txtInst[f], tFontsUpdateCacheList);		

	loadedTypekitCount++;		
	if(loadedTypekitCount == totalTypekitCount) {		
		lib.updateListCache(tFontsUpdateCacheList);		
	}		
};
// symbols:



(lib.Symbol0 = function() {
	this.spriteSheet = ss["maket_atlas_"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.Symbol1 = function() {
	this.spriteSheet = ss["maket_atlas_"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.Symbol10 = function() {
	this.spriteSheet = ss["maket_atlas_"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.Symbol11 = function() {
	this.spriteSheet = ss["maket_atlas_"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.Symbol12 = function() {
	this.spriteSheet = ss["maket_atlas_"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.Symbol2 = function() {
	this.spriteSheet = ss["maket_atlas_"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.Symbol3 = function() {
	this.spriteSheet = ss["maket_atlas_"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.Symbol4 = function() {
	this.spriteSheet = ss["maket_atlas_"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.Symbol5 = function() {
	this.spriteSheet = ss["maket_atlas_"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.Symbol6 = function() {
	this.spriteSheet = ss["maket_atlas_"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.Symbol7 = function() {
	this.spriteSheet = ss["maket_atlas_"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.Symbol8 = function() {
	this.spriteSheet = ss["maket_atlas_"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.Symbol9 = function() {
	this.spriteSheet = ss["maket_atlas_"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.title = function() {
	this.spriteSheet = ss["maket_atlas_"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.WinWindow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.txt = new cjs.Text("Вы выиграли: 0 G", "bold 52px 'Panton'", "#FFFFFF");
	this.txt.name = "txt";
	this.txt.textAlign = "center";
	this.txt.lineHeight = 52;
	this.txt.lineWidth = 589;
	this.txt.parent = this;
	this.txt.setTransform(237.5,38.7);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#025F76").s().p("Egs3AJxQhLAAgugbQgOgJgLgKQg2gyAAhoIAAtRQAAjIDIAAMBZvAAAQBdAAAyArQAPANALAQQAfAxAABPIAANRQAADIjIAAg");
	this.shape.setTransform(235.8,64.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.txt}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.WinWindow, new cjs.Rectangle(-71.4,1.9,614.5,125), null);


(lib.SymbolsContainer = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

}).prototype = getMCSymbolPrototype(lib.SymbolsContainer, null, null);


(lib.Row = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.lf(["#B1B1B1","#D7D7D7","#C1C1C1","#CCCCCC"],[0,0.231,0.635,1],-149.2,-125.5,-118.1,125.6).s().p("EhLzAN3QjkAAAAjiIAA0oQAAjjDkAAMCbLAAAIAAbtg");
	this.shape.setTransform(509,88.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.Row, new cjs.Rectangle(1,0,1016,177.4), null);


(lib.Line8 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Слой 3
	this.shape = new cjs.Shape();
	this.shape.graphics.lf(["#99FF33","#99CC00"],[0,1],-538.7,-5.9,519.1,-5.9).s().p("EhSyAfJQgUAAgNgOQgOgOgBgTQABgUAOgOQANgNAUAAMAvtAAAMA3yg8jQAGgHAJgFQAKgEAKAAMA9jAAAQAUAAAPAOQAMAOAAATQAAAUgMANQgPAOgUAAMg9NAAAMg3yA8jQgIAIgJAEQgKAEgKAAg");
	this.shape.setTransform(543,55.8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.Line8, new cjs.Rectangle(8.3,-143.4,1069.3,398.5), null);


(lib.Line7 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Слой 2
	this.shape = new cjs.Shape();
	this.shape.graphics.lf(["#FF99FF","#FF00FF"],[0,1],-534.1,-2.2,511.4,-2.2).s().p("AVMfNQgKgBgJgEQgJgDgHgIMg3ng8rMgvkAAAQgUAAgOgNQgOgOAAgUQAAgTAOgNQAOgOAUgBMAv4AAAQAKAAAJAEQAKAFAGAHMA3pA8rMA9CAAAQATAAAPAOQANANAAATQAAAUgNAOQgPAOgTAAg");
	this.shape.setTransform(542.6,199.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.Line7, new cjs.Rectangle(9.5,0,1066.2,399.3), null);


(lib.Line6 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Слой 2
	this.shape = new cjs.Shape();
	this.shape.graphics.lf(["#00CBFF","#0099FF"],[0,1],-536.1,-7.9,513.2,-7.9).s().p("EA0yAR9QgLABgIgFQgKgEgHgJMgblgh/Mg42AAAMgbkAh/QgHAJgIAEQgLAFgKgBI2bAAQgUAAgNgOQgOgRAAgVQAAgWAOgQQANgPAUAAIWGAAMAbkgh/QAIgJAJgFQAJgEAKAAMA5gAAAQALAAAKAEQAJAFAGAJMAblAh/IdqAAQAUAAAPAPQAMAQAAAWQAAAVgMARQgPAOgUAAg");
	this.shape.setTransform(542.7,18.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.Line6, new cjs.Rectangle(8.3,-96.7,1068.9,229.9), null);


(lib.Line5 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Слой 2
	this.shape = new cjs.Shape();
	this.shape.graphics.lf(["#00FE00","#00CC00"],[0,1],-542.6,-0.5,522.7,-0.5).s().p("EgglAQPQgKAAgJgEQgKgEgIgHI7n+vI2IAAQgUAAgNgNQgPgOAAgUQAAgUAPgOQANgOAUAAIWeAAQAKAAAJAEQAKAEAHAIIbneuMA48AAAIbo+uQAHgIAKgEQAIgEALAAIeCAAQAVAAANAOQAOAOAAAUQAAAUgOAOQgNANgVAAI9tAAI7nevQgIAHgIAEQgKAEgLAAg");
	this.shape.setTransform(458,28.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.Line5, new cjs.Rectangle(-77.4,-75.5,1070.8,207.8), null);


(lib.Line4 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Слой 2
	this.shape = new cjs.Shape();
	this.shape.graphics.lf(["#FFFF00","#FFCC00"],[0,1],-538.2,1,512.4,1).s().p("EA7CAj8QgKAAgJgEQgKgEgGgIMg+OhFuMg+MBFuQgIAIgIAEQgKAEgKAAIwXAAQgVAAgNgOQgPgOAAgUQAAgUAPgOQANgOAVAAIQBAAMA+ihGHQAKgKAOgEQAMgEAOAEQANAEAJAKMA+jBGHIXgAAQAUAAAOAOQANAOAAAUQAAAUgNAOQgOAOgUAAg");
	this.shape.setTransform(543.5,59.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.Line4, new cjs.Rectangle(8.3,-170.5,1070.3,460), null);


(lib.Line3 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Слой 2
	this.shape = new cjs.Shape();
	this.shape.graphics.lf(["#FFCC00","#FF9900"],[0,1],-538.4,3,518.9,3).s().p("EgD7AjxQgNgFgJgKMg+RhFzIv+AAQgTAAgOgOQgPgOAAgVQAAgTAPgNQAOgPATAAIQTAAQAKAAAKAEQAJAEAGAIMA99BFcMA97hFcQAHgIAJgEQAKgEAKAAIXvAAQAUAAAOAPQANANAAATQAAAVgNAOQgOAOgUAAI3ZAAMg+SBFzQgKAKgMAFIgNABQgHAAgHgBg");
	this.shape.setTransform(542.9,225.9);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.Line3, new cjs.Rectangle(10,-3.1,1065.7,458), null);


(lib.Line012 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.lf(["#FF0000","#990000"],[0,1],-504.5,-127.4,486.3,185.2).s().p("EhSzAAwQgVAAgMgOQgPgOgBgUQABgTAPgOQAMgOAVAAMCloAAAQAUAAAOAOQAOAOAAATQAAAUgOAOQgOAOgUAAg");
	this.shape.setTransform(398.2,4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.Line012, new cjs.Rectangle(-136.7,-0.8,1069.7,9.7), null);


(lib.FreeSpinsWindow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.txt = new cjs.Text("Вы выиграли\n15 бесплатных розыгрышей", "bold 46px 'Panton'", "#FFFFFF");
	this.txt.name = "txt";
	this.txt.textAlign = "center";
	this.txt.lineHeight = 51;
	this.txt.lineWidth = 638;
	this.txt.parent = this;
	this.txt.setTransform(337,37);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#025F76").s().p("EgyXANbQikAAAAiqIAA1hQAAiqCkAAMBkvAAAQCkAAAACqIAAVhQAACqikAAg");
	this.shape.setTransform(338.8,85.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.txt}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.FreeSpinsWindow, new cjs.Rectangle(0,0,677.7,171.8), null);


(lib.FreeSpinsMulti = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

}).prototype = getMCSymbolPrototype(lib.FreeSpinsMulti, null, null);


(lib.FreeSpinsBg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Слой 3
	this.shape = new cjs.Shape();
	this.shape.graphics.lf(["#CFD4D0","#ABAFB2","#C4CDCA","#C1BDB4"],[0,0.196,0.604,1],452.7,-52.1,452.3,54.8).s().p("AiyHmIyYsUQhHgwgKgvIgDgNIAAgCIAAgCIAAgIIAAgGIACgLIABgHIABgGIAAABQALghAmgZQA0giBJgCIABAAMAnYAAAIACAAQBIACAyAiIACAAQAlAaALAgIABAGQAFATgDATIAAAAIgCAGIAAAEQgMAwhGAvIyYMUQhZA7hZAAQhYAAhag7gA03nbQgXAQgGATIgCAFIgCANIABAEIABAFIAAAGQAKAkA0AjISYMUQCABWCAhWISYsUQA0giAKgkIACgGQACgNgEgLIAAgDQgHgVgXgPQgfgVgsgBMgnYAAAQgtABgfAVg");
	this.shape.setTransform(143.9,54.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Слой 1
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#025F76").s().p("AiAHFIyYsTQg0gkgKgjIAAgHIgBgEIgBgFIACgMIACgGQAGgTAXgQQAfgUAtgBMAnYAAAQAsABAfAUQAXAQAHAUIAAADQAEAMgCAMIgCAHQgKAjg0AjIyYMTQhAAshAAAQg/AAhBgsg");
	this.shape_1.setTransform(143.9,54.4);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

}).prototype = getMCSymbolPrototype(lib.FreeSpinsBg, new cjs.Rectangle(0,0,287.8,109.1), null);


(lib.DoubleFrame = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.lf(["#FFCC00","#FF9900"],[0,1],-38.4,-47.1,1.5,50.1).s().p("AlQIoIAAgBQjYgMgMjYIgBAAIAAqFIABAAQAMjXDYgNIAAgBIKhAAIAAABQDYANANDXIAAAAIAAKFIAAAAQgNDYjYAMIAAABgAn8ksIAAJaQAEC9C9AEIJ2AAQC+gEAEi9IAApaQgEi+i+gDIp2AAQi9ADgEC+g");
	this.shape.setTransform(59,56.9);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.lf(["#FFCC00","#FF9900"],[0,1],-41.3,-50.8,1.8,54.1).s().p("AlqJTIAAAAQjpgOgOjpIgBAAIAAq3IABAAQAOjoDpgOIAAgBILVAAIAAABQDpAOAODoIABAAIAAK3IgBAAQgODpjpAOIAAAAgAo1FGIABAAQANDYDXAMIAAABIKhAAIAAgBQDYgMANjYIABAAIAAqFIgBAAQgNjXjYgNIAAgBIqhAAIAAABQjXANgNDXIgBAAg");
	this.shape_1.setTransform(59,56.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.DoubleFrame, new cjs.Rectangle(-2.1,-2.9,122.2,119.1), null);


(lib.DoubleBg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.lf(["#B4B4B4","#D4D4D4","#B4B4B4","#CDCDCD","#ADADAD"],[0,0.345,0.486,0.682,1],104.3,-49.5,260.4,534).s().p("AFuJdIrfAAIgIAAQhbgDg4gmQhEgsgUhaQgGgZgBgbIgBgFIgCrIQAAg1AKgqQALglAOgbQAthMBhgWQAagGAcgBIAagBILeAAQBCABAyATQAtARAfAiQAfAgAPAwIAMA0QAEAdAAAhIAAKnIgBAMIAAAGQgMBwg2A+Qg8BBhvAIIgGAAIgNAAg");
	this.shape.setTransform(61.1,59.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.DoubleBg, new cjs.Rectangle(-1.2,-1.2,124.6,121.1), null);


(lib.DemoText = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.text = new cjs.Text("Демо", "bold 52px 'Panton'", "#B7E1E1");
	this.text.textAlign = "center";
	this.text.lineHeight = 54;
	this.text.lineWidth = 161;
	this.text.parent = this;
	this.text.setTransform(1172.9,23.8);

	this.text_1 = new cjs.Text("Демо", "bold 52px 'Panton'", "#B7E1E1");
	this.text_1.textAlign = "center";
	this.text_1.lineHeight = 54;
	this.text_1.lineWidth = 161;
	this.text_1.parent = this;
	this.text_1.setTransform(109.9,24.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.text_1},{t:this.text}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.DemoText, new cjs.Rectangle(27.3,21.8,1228.3,56.7), null);


(lib.Contours = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.lf(["#B4B4B4","#D4D4D4","#B4B4B4","#CDCDCD","#ADADAD"],[0,0.345,0.486,0.682,1],54.3,-285.9,207.3,286).s().p("EAB6AqoIAAgEIABgNIAAqaQABjzjigQIgEgCIAEABQAiACAcAHIABAAIAFACIAEAAIATAGIAHADQAEAAAEAEIAZAMIACABIAIAGQAYARATAXQAwBBAABwIAAKaIgBANIAAAEQgTDKijAiQCdgnASjFgAAcbLQBRg+ANiJIAAgEIABgNIAAqbQAAkAj8gDQDkgFAXjvIAAgGIABgMIAAqZQAAkBj8gEQDkgEAXjwIAAgFIABgMIAAqbQABgxgKgoIAPA2IABAVIAAAAIAAAGIAAABIAAADIAAADIAAABIAAKbIgBAMIAAAFQgXDwjlAEQAvAAAkAKQAlAKAdAQIAZASIADABIAEADIAAABIAPAOIAAAAIAHAKIACACQAGAGAEAIIAAABIAbA8IAGAfIAAACIACAEIAAACIAAACIABAGIABAEIABAXQAAAAAAAAQgBABAAAAQAAAAABAAQAAAAAAAAIAAAIQAAAAAAABQgBAAAAAAQAAABABAAQAAAAAAAAIAAAKIAAADIAAADIAAKZIgBAMIAAAGQgXDvjlAFQAvAAAlAJQAJABAGAEQATAFAQAHIAZAPIAGAEIAKAIIAcAdIAHAIQApA7ACBiIAAABIAAALIAAKbIgBANIAAAEQgOCJhQA+Qg1AmhUAHQBOgIA0glgAiB7yIAUgBIAAABIgDAAIADAAIAIAAIAKABIgmgBgAB6/nIAAgEIABgMIAAqbQAAgggDgdIAKAwIAAABIAAAEIAAAGIAAACIAAKbIgBAMIAAAEQgJBXgjA5IgDAFIgJAMIgDADIgCABIAAABIgKAFQA1g8ALhvgEAA/gtRIAPALIABABIAGAHIAJAOIAGAKIAHAlQgPgwgdgggEgBUguUIAKAAIANACIAKACIAcAHIADABIAJAFQghgLgogGg");
	this.shape.setTransform(63.9,286.9);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(255,255,255,0.702)").s().p("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");
	this.shape_1.setTransform(548.6,288);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.Contours, new cjs.Rectangle(-46.9,-13.1,1191.1,602.2), null);


(lib.FreeSpinsWin = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.text = new cjs.Text("ОБЩИЙ ВЫИГРЫШ", "bold 20px 'Panton'", "#FFFFFF");
	this.text.textAlign = "center";
	this.text.lineHeight = 22;
	this.text.lineWidth = 193;
	this.text.parent = this;
	this.text.setTransform(144.3,16);

	this.win = new cjs.Text("99999 G", "bold 30px 'Panton'", "#FED969");
	this.win.name = "win";
	this.win.textAlign = "center";
	this.win.lineHeight = 30;
	this.win.lineWidth = 198;
	this.win.parent = this;
	this.win.setTransform(145.6,42.3);

	this.instance = new lib.FreeSpinsBg();
	this.instance.parent = this;
	this.instance.setTransform(143.9,54.6,1,1,0,0,0,143.9,54.6);
	this.instance.cache(-2,-2,292,113);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.win},{t:this.text}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.FreeSpinsWin, new cjs.Rectangle(0,0,287.8,109.1), null);


(lib.FreeSpinsAmount = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// text
	this.text = new cjs.Text("ПРИЗОВЫХ ИГР", "bold 20px 'Panton'", "#FFFFFF");
	this.text.textAlign = "center";
	this.text.lineHeight = 22;
	this.text.lineWidth = 275;
	this.text.parent = this;
	this.text.setTransform(143.7,16);

	this.amount = new cjs.Text("999", "bold 30px 'Panton'", "#FED969");
	this.amount.name = "amount";
	this.amount.textAlign = "center";
	this.amount.lineHeight = 30;
	this.amount.lineWidth = 111;
	this.amount.parent = this;
	this.amount.setTransform(142.4,42);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.amount},{t:this.text}]}).wait(1));

	// bg
	this.instance = new lib.FreeSpinsBg();
	this.instance.parent = this;
	this.instance.setTransform(143.9,54.6,1,1,0,0,0,143.9,54.6);
	this.instance.cache(-2,-2,292,113);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.FreeSpinsAmount, new cjs.Rectangle(0,0,287.8,109.1), null);


(lib.FreeSpins = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.freeSpinsWindow = new lib.FreeSpinsWindow();
	this.freeSpinsWindow.parent = this;
	this.freeSpinsWindow.setTransform(640.8,313.9,1,1,0,0,0,338.8,85.9);

	this.freeSpinsWin = new lib.FreeSpinsWin();
	this.freeSpinsWin.parent = this;
	this.freeSpinsWin.setTransform(152.9,80.6,1,1,0,0,0,143.9,54.6);

	this.freeSpinsMulti = new lib.FreeSpinsMulti();
	this.freeSpinsMulti.parent = this;
	this.freeSpinsMulti.setTransform(1085,638,1,1,0,0,0,62,61);

	this.freeSpinsAmount = new lib.FreeSpinsAmount();
	this.freeSpinsAmount.parent = this;
	this.freeSpinsAmount.setTransform(1016.9,80.6,1,1,0,0,0,143.9,54.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.freeSpinsAmount},{t:this.freeSpinsMulti},{t:this.freeSpinsWin},{t:this.freeSpinsWindow}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.FreeSpins, new cjs.Rectangle(9,26,1151.8,373.8), null);


(lib.Double = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// x2
	this.txt = new cjs.Text("x2", "bold 46px 'Panton'", "#FFFFFF");
	this.txt.name = "txt";
	this.txt.textAlign = "center";
	this.txt.lineHeight = 46;
	this.txt.lineWidth = 59;
	this.txt.parent = this;
	this.txt.setTransform(60.8,37.9);
	this.txt.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,5);

	this.timeline.addTween(cjs.Tween.get(this.txt).wait(1));

	// DoubleBg
	this.frame = new lib.DoubleFrame();
	this.frame.parent = this;
	this.frame.setTransform(61.1,59.4,1,1,0,0,0,59.1,56.9);
	this.frame.cache(-4,-5,126,123);

	this.bg = new lib.DoubleBg();
	this.bg.parent = this;
	this.bg.setTransform(61.1,59.4,1,1,0,0,0,61.1,59.4);
	this.bg.cache(-3,-3,129,125);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bg},{t:this.frame}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.Double, new cjs.Rectangle(-1.2,-1.2,124.6,121.1), null);


(lib.MainScreen = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// free_spins
	this.freeSpins = new lib.FreeSpins();
	this.freeSpins.parent = this;
	this.freeSpins.setTransform(675.9,337.2,1,1,0,0,0,575.9,337.2);

	this.timeline.addTween(cjs.Tween.get(this.freeSpins).wait(1));

	// title
	this.instance = new lib.title();
	this.instance.parent = this;
	this.instance.setTransform(415,16);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// win_window
	this.winWindow = new lib.WinWindow();
	this.winWindow.parent = this;
	this.winWindow.setTransform(736,319,1,1,0,0,0,237,63.8);

	this.timeline.addTween(cjs.Tween.get(this.winWindow).wait(1));

	// demo
	this.demoText = new lib.DemoText();
	this.demoText.parent = this;
	this.demoText.setTransform(642.9,76.5,1,1,0,0,0,644.1,80.8);

	this.timeline.addTween(cjs.Tween.get(this.demoText).wait(1));

	// symbols
	this.symbolsContainer = new lib.SymbolsContainer();
	this.symbolsContainer.parent = this;
	this.symbolsContainer.setTransform(8.2,8.2,1,1,0,0,0,8.2,8.2);

	this.timeline.addTween(cjs.Tween.get(this.symbolsContainer).wait(1));

	// lines
	this.line3 = new lib.Line3();
	this.line3.parent = this;
	this.line3.setTransform(180.5,152);
	this.line3.cache(8,-5,1070,462);

	this.line7 = new lib.Line7();
	this.line7.parent = this;
	this.line7.setTransform(181,180.9);
	this.line7.cache(8,-2,1070,403);

	this.line6 = new lib.Line6();
	this.line6.parent = this;
	this.line6.setTransform(180.5,244.8);
	this.line6.cache(6,-99,1073,234);

	this.line1 = new lib.Line012();
	this.line1.parent = this;
	this.line1.setTransform(326.5,165.9);
	this.line1.cache(-139,-3,1074,14);

	this.line0 = new lib.Line012();
	this.line0.parent = this;
	this.line0.setTransform(324.5,386);
	this.line0.cache(-139,-3,1074,14);

	this.line8 = new lib.Line8();
	this.line8.parent = this;
	this.line8.setTransform(180.5,324.3);
	this.line8.cache(6,-145,1073,403);

	this.line5 = new lib.Line5();
	this.line5.parent = this;
	this.line5.setTransform(265.4,478.5);
	this.line5.cache(-79,-77,1075,212);

	this.line4 = new lib.Line4();
	this.line4.parent = this;
	this.line4.setTransform(178.5,322.6);
	this.line4.cache(6,-172,1074,464);

	this.line2 = new lib.Line012();
	this.line2.parent = this;
	this.line2.setTransform(323.5,587.1);
	this.line2.cache(-139,-3,1074,14);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.line2},{t:this.line4},{t:this.line5},{t:this.line8},{t:this.line0},{t:this.line1},{t:this.line6},{t:this.line7},{t:this.line3}]}).wait(1));

	// rows
	this.row2 = new lib.Row();
	this.row2.parent = this;
	this.row2.setTransform(722.4,595.8,1,1,0,0,0,509,88.8);
	this.row2.cache(-1,-2,1020,181);

	this.row1 = new lib.Row();
	this.row1.parent = this;
	this.row1.setTransform(722.4,386.6,1,1,0,0,0,509,88.8);
	this.row1.cache(-1,-2,1020,181);

	this.row0 = new lib.Row();
	this.row0.parent = this;
	this.row0.setTransform(722.4,178.8,1,1,0,0,0,509,88.8);
	this.row0.cache(-1,-2,1020,181);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.row0},{t:this.row1},{t:this.row2}]}).wait(1));

	// double
	this.x32 = new lib.Double();
	this.x32.parent = this;
	this.x32.setTransform(108.1,625.5,1,1,0,0,0,61.1,59.4);

	this.x16 = new lib.Double();
	this.x16.parent = this;
	this.x16.setTransform(108.1,506.6,1,1,0,0,0,61.1,59.4);

	this.x8 = new lib.Double();
	this.x8.parent = this;
	this.x8.setTransform(107.5,388.1,1,1,0,0,0,61.1,59.4);

	this.x4 = new lib.Double();
	this.x4.parent = this;
	this.x4.setTransform(108.1,269.6,1,1,0,0,0,61.1,59.4);

	this.x2 = new lib.Double();
	this.x2.parent = this;
	this.x2.setTransform(108.5,150.1,1,1,0,0,0,61.1,59.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.x2},{t:this.x4},{t:this.x8},{t:this.x16},{t:this.x32}]}).wait(1));

	// contours
	this.instance_1 = new lib.Contours();
	this.instance_1.parent = this;
	this.instance_1.setTransform(645.9,358.4,1,1,0,0,0,554.9,259.4);
	this.instance_1.cache(-49,-15,1195,606);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

}).prototype = getMCSymbolPrototype(lib.MainScreen, new cjs.Rectangle(26.1,16,1234.8,674.6), null);


// stage content:
(lib.vozdushnydesant = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// MainScreen
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("AgEovIAJAAAAFIwIgIgB");
	this.shape.setTransform(1190.5,663.9);

	this.instance = new lib.MainScreen();
	this.instance.parent = this;
	this.instance.setTransform(265.5,36.5,1,1,0,0,0,265.5,36.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.shape}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(640,360,1260.8,720.9);
// library properties:
lib.properties = {
	width: 1280,
	height: 720,
	fps: 24,
	color: "#999999",
	opacity: 1.00,
	webfonts: {},
	manifest: [
		{src:"img/maket_atlas_.png", id:"maket_atlas_"}
	],
	preloads: []
};




})(lib = lib||{}, images = images||{}, createjs = createjs||{}, ss = ss||{}, AdobeAn = AdobeAn||{});
var lib, images, createjs, ss, AdobeAn;


/*** EXPORTS FROM exports-loader ***/
exports["lib"] = (lib);
exports["ss"] = (ss);


// WEBPACK FOOTER //
// ./temp/maket.js